var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserX = function SvgUserX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M11 10.667 14.333 14m0-3.333L11 14m-3-3.667H5c-.93 0-1.396 0-1.774.115a2.67 2.67 0 0 0-1.778 1.778c-.115.378-.115.844-.115 1.774m8.334-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  })));
};
export default SvgUserX;